import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { Shift } from '@sdk/automatedBreaks/types/Shift';

import { useScheduledRowContent } from '@web/timeClock/modals/rows/ScheduledRow/scheduledRowContent.hooks';

type Props = {
  shift: Shift;
};

const ScheduledRowContent = ({ shift }: Props) => {
  const { displayLabel, displaySummary } = useScheduledRowContent(shift);

  if (!shift.duration) {
    return (
      <Column>
        <Text14 themeColor={ThemeColorType.gray}>{gettext('This shift is unscheduled')}</Text14>
      </Column>
    );
  }

  return (
    <Column>
      <Text14 themeColor={ThemeColorType.gray}>{displayLabel}</Text14>
      <Text14 themeColor={ThemeColorType.gray}>{displaySummary}</Text14>
    </Column>
  );
};

export default ScheduledRowContent;
